export const FETCH_PERMISSIONS = "FETCH_PERMISSIONS";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_PERMISSIONS_FAILURE = "FETCH_PERMISSIONS_FAILURE";

export interface PermissionsState {
  agentStudio: {
    grantedPermissions: string[];
    isLoading: boolean;
    error: string | null;
  };
}
